import type { ReactElement } from 'react';

type SupplierHoverCardInfoRowProps = {
  label: string;
  value?: string | number | null;
};

export function SupplierHoverCardInfoRow({
  label,
  value,
}: SupplierHoverCardInfoRowProps): ReactElement {
  return (
    <>
      {value && (
        <div className='flex justify-between gap-4'>
          <span className='text-muted-foreground text-sm'>{label}</span>
          <span className='font-medium text-sm'>{value}</span>
        </div>
      )}
    </>
  );
}
